// extracted by mini-css-extract-plugin
module.exports = {"exerciseBox5":"L5_exerciseBox5__2OOTr","badanswer":"L5_badanswer__1XLzY"};